module.exports = __webpack_public_path__ + "img/ch_gallery_1.7e50638b.jpg";